import { render, staticRenderFns } from "./item-introduction.vue?vue&type=template&id=389a3cb4&scoped=true&"
import script from "./item-introduction.vue?vue&type=script&lang=js&"
export * from "./item-introduction.vue?vue&type=script&lang=js&"
import style0 from "./item-introduction.vue?vue&type=style&index=0&id=389a3cb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389a3cb4",
  null
  
)

export default component.exports